import { QuestionReqModel } from "./question-req-model";

export class SetAndQuestionMappingsModel {
    setNo: number;
    sectionsMapping: QuestionReqModel[]
    constructor(
        setNo: number,
        sectionsMapping: QuestionReqModel[]
    ) {
        this.setNo = setNo;
        this.sectionsMapping = sectionsMapping;
    }
}